import React, { useId } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import TemplateSetupField from '../ProjectDag/TemplateSetupField';

const ClarificationAnswerField = ({
  inputType = 'text', caseid, label, value, onChange, disabled = false,
  emphasized = false,
  ...textFieldProps
}) => {
  const generatedId = useId();
  const answerId = textFieldProps.id || generatedId;
  if (inputType === 'file' || inputType === 'folder') {
    return (
      <Box role="group" aria-label={label}>
        <Typography variant={emphasized ? 'subtitle1' : 'body2'} sx={{ fontWeight: emphasized ? 700 : 600,
          whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', lineHeight: 1.5 }}>{label}</Typography>
        <TemplateSetupField
          field={{ type: inputType, required: true, label }}
          caseid={caseid} value={value} saving={disabled} onChange={onChange}
          emphasizeStoragePicker={emphasized}
        />
      </Box>
    );
  }
  const control = <TextField {...textFieldProps} id={answerId} fullWidth size={emphasized ? 'medium' : 'small'}
    label={emphasized ? undefined : label}
    value={value} disabled={disabled} onChange={(event) => onChange(event.target.value)} />;
  if (!emphasized) return control;
  return <Box>
    <Typography component="label" htmlFor={answerId} variant="subtitle1"
      sx={{ display: 'block', mb: 1.5, fontWeight: 700, whiteSpace: 'pre-wrap',
        overflowWrap: 'anywhere', lineHeight: 1.5 }}>{label}</Typography>
    {control}
  </Box>;
};

export default ClarificationAnswerField;
